import { AppState } from './AppState';

export class InvalidState extends AppState {
  handle(): void {
    this.renderWelcomeApp();
  }
}
